import { WidgetRegistryEntry } from "@smallstack/widget-core";

export const CmsPageWidget: WidgetRegistryEntry = {
  name: "CmsPage",
  configuration: () => import("./configuration").then((m) => m.CmsPageWidgetConfiguration),
  component: () => import("./cms-page-widget.component").then((m) => m.CmsPageWidgetComponent)
};
